/**
 * 섹션 이동 메뉴(.spy-nav).
 *
 * 가로로 눕는 좁은 화면에서는 현재 항목이 화면 밖에 있을 수 있다.
 * 현재 항목(--current)이 바뀌면 목록 안에서만 가로로 밀어 가운데에 보여 준다.
 * (scrollIntoView 는 페이지까지 같이 움직여서 쓰지 않는다)
 */

const centerCurrent = (list) => {
  const current = list.querySelector('.spy-nav__link--current');

  // 세로로 서 있으면(스크롤이 없으면) 할 일이 없다
  if (!current || list.scrollWidth <= list.clientWidth) {
    return;
  }

  const target = current.offsetLeft - (list.clientWidth - current.offsetWidth) / 2;

  list.scrollTo({ left: Math.max(target, 0), behavior: 'smooth' });
};

const InitSpyNav = () => {
  const lists = document.querySelectorAll('.spy-nav__list');

  lists.forEach((list) => {
    centerCurrent(list);

    // 스크롤을 따라 현재 항목이 바뀌면(다른 코드가 class 를 갈아 끼운다) 따라 움직인다
    const observer = new MutationObserver(() => centerCurrent(list));

    observer.observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  });
};

export default InitSpyNav;
